module.exports = __webpack_public_path__ + "img/favicon.b2a9e0cf.png";